import './ButtomSection.css';

function ButtomSection({ }) {

return (
<section  className="ButtomSection">
<p>
<span>
בעיות מייל? נסו את זה: alonkerklies@gmail.com
</span>
|
<span  className="noBreak">א-ה 09:00-19:00</span>
|
<span>0508020693</span>
|
<span>©Kerk</span>
</p>
</section >
);
}
export default ButtomSection;